/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import {
  IconButton, List, ListItem, Tooltip,
} from '@material-ui/core';
import { FileCopy, Folder } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import userServices from '../../../../redux/services/userServices';
import { generatePDF } from '../../../Company/components/generatePdf';
import reportServices from '../../../../redux/services/reportServices';
import { edusignServices } from '../../../../redux/services/edusignServices';
import groupServices from '../../../../redux/services/groupServices';

const handleGenerateReport = (courseInfos) => {
  if (courseInfos.reports.coursePlan !== undefined && courseInfos.reports.report !== undefined) {
    const arr = [];
    let contentTitles = [];
    const { specificSkills } = courseInfos.reports.coursePlan;
    if (courseInfos.reports.coursePlan.formationContent !== undefined) {
      courseInfos.reports.coursePlan.formationContent.forEach((item) => {
        arr.push(...item.skillTitle);
      });
      const ids = arr.map((item) => item._id);
      contentTitles = arr.filter(({ _id }, index) => !ids.includes(_id, index + 1));

      if (contentTitles !== undefined) {
        contentTitles.forEach((contentTitle) => {
          const content = [];
          contentTitle.skills.forEach((contentId) => {
            courseInfos.reports.coursePlan.formationContent.forEach((contentObj) => {
              if (contentId === contentObj._id) {
                content.push(contentObj);
              }
            });
          });
          contentTitle.content = content;
        });
      }
    }
    courseInfos.reports.listIdUsers.forEach((userObj) => {
      if (userObj._id === courseInfos.reports.report.student) {
        const finalReport = { ...courseInfos.reports.report };

        if (finalReport.customPresence !== undefined && finalReport.customPresence !== null && !Number.isNaN(finalReport.customPresence)) {
          finalReport.presenceSummary = {
            present: finalReport.customPresence,
            missing: (Number(courseInfos?.reports.coursePlan.duration) || 0) - (Number(finalReport?.customPresence) || 0),
            justified: 0,
          };
        }
        generatePDF(courseInfos.reports, finalReport,
          userObj, contentTitles, specificSkills);
      }
    });
  }
};

const StudentsInGroupList = ({ groupId, students, loadData }) => {
  const [loading, setLoading] = useState(true);
  const [updatedStudents, setUpdatedStudents] = useState([]);

  const getData = async () => {
    setLoading(true);
    try {
      const group = await groupServices.getGroupById(groupId);
      if (students && group) {
        const studentsWithReports = await Promise.all(
          students.map(async (item) => {
            const res = await groupServices.getPDF(groupId);
            if (res) {
              res.group = group.name;
              const reportObj = await reportServices
                .getReportByStudent(item._id, res.coursePlan._id);
              if (reportObj.status === 200) {
                res.report = reportObj.data;
                const edusignStudent = await edusignServices.getStudent(item.email);
                if (edusignStudent && edusignStudent.ID) {
                  const presenceSummary = await edusignServices.getStudentPresenceSummary(
                    edusignStudent.ID,
                    new Date(res.coursePlan.beginDate).toISOString(),
                    new Date(res.coursePlan.endDate).toISOString(),
                  );
                  if (presenceSummary && presenceSummary.present) {
                    res.report.presenceSummary = presenceSummary;
                  }
                }
                item.reports = res;
              }
            }
            return item;
          }),
        );

        setUpdatedStudents(studentsWithReports);
      }
    } catch (e) {
      // console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [students]);

  return (
    <MaterialTable
      title="Students in group"
      data={updatedStudents}
      style={{
        width: '48%',
        height: '100%',
        zIndex: 0,
      }}
      columns={[
        {
          title: 'Last name',
          field: 'name',
        },
        {
          title: 'First name',
          field: 'firstname',
        },
        {
          title: 'Email',
          field: 'email',
        },
        {
          title: 'Reports',
          field: 'reports',
          render: (rowData) => (
            <Tooltip title="See reports">
              <IconButton
                variant="contained"
                color="primary"
                disableElevation
                component={Link}
                to={`/student/report/${rowData._id}`}
              >
                <Folder style={{ fontSize: '30px' }} />
              </IconButton>
            </Tooltip>
          ),
        },
        {
          title: 'Download report',
          field: 'reports',
          render: (rowData) => (
            <IconButton
              disabled={rowData.reports?.report === undefined || rowData.reports?.report?.validation?.status === 'unfinished'}
              onClick={() => handleGenerateReport(rowData)}
            >
              <FileCopy
                style={{
                  color: (rowData.reports?.report === undefined || rowData.reports?.report?.validation?.status === 'unfinished') ? '#B3B3B3' : '#303f9f',
                  width: '30px',
                  height: '30px',
                }}
              />
            </IconButton>
          ),
        },
        {
          title: 'Needs',
          field: 'needs',
          hidden: true,
          hiddenByColumnsButton: true,
          width: '10%',
          render: (rowData) => rowData.needs && (
          <List>
            {Object.entries(rowData.needs).map(([key, value]) => (value
                  && !key.includes('other')
                  && !key.includes('objectives') ? (
                    <ListItem key={key}>{key}</ListItem>
              ) : null))}
          </List>
          ),
        },
      ]}
      options={{
        columnsButton: true,
        selection: true,
        pageSize: 10,
      }}
      isLoading={loading}
      actions={[
        {
          icon: 'delete',
          tooltip: 'delete students from group',
          onClick: async (event, rowData) => {
            await Promise.all(
              rowData.map(async (student) => {
                await userServices.deleteUsersFromGroup(groupId, student._id);
              }),
            );
            loadData();
          },
        },
      ]}
    />
  );
};

StudentsInGroupList.propTypes = {
  students: PropTypes.array.isRequired,
  groupId: PropTypes.string.isRequired,
  loadData: PropTypes.func.isRequired,
};

export default StudentsInGroupList;
